exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".createGroup_from_GroupCreate-css_3WJ {\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-align: center;\r\n      -ms-flex-align: center;\r\n          align-items: center;\r\n  -webkit-box-pack: center;\r\n      -ms-flex-pack: center;\r\n          justify-content: center;\r\n  padding: 20px\r\n}\n.createGroup_from_GroupCreate-css_3WJ > input {\r\n  margin-right: 10px;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"createGroup": "createGroup_from_GroupCreate-css_3WJ"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--3-1!./node_modules/postcss-loader/lib??ref--3-2!./app/web/src/routes/sales/Lead/BusinessGroup/GroupCreate.css
// module id = ./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/routes/sales/Lead/BusinessGroup/GroupCreate.css
// module chunks = 0